import { LookupApi, LookupField } from './../../../../core/api.gen';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from 'src/app/core/loader.service';
import { finalize } from 'rxjs/operators';
import { ToastService } from 'src/app/core';
import { LookupTypeKeys } from 'src/app/shared/lookup-type-keys';
import { Observable } from 'rxjs';
import { CommonService } from 'src/app/core/common.service';

@Component({
  selector: 'eos-lookup-type-amendment-edit',
  templateUrl: './lookup-type-amendment-edit.component.html',
  styleUrls: ['./lookup-type-amendment-edit.component.css']
})
export class LookupTypeAmendmentEditComponent implements OnInit {

  @Input() public lookupField: LookupField;
  @Input() public isEdit: boolean;
  @Input() public lookUpTypeId: number;
  @Input() public module: string;

  lktypes = [];
  immigrationCaseTypes$: Observable<LookupField[]>;
  mappedICTs = [];
  documentTypes =[];
  isDefaultText : boolean = true;
  amendLookup = new UntypedFormGroup({
    id: new UntypedFormControl(),
    displayText: new UntypedFormControl(null, [Validators.required]),
    order: new UntypedFormControl(),
    isActive: new UntypedFormControl(),
    lookupTypeId: new UntypedFormControl([], [Validators.required]),
    ict: new UntypedFormControl([]),
    mappingLookUpFieldId: new UntypedFormControl(),
    value: new UntypedFormControl(),
    parentFieldId: new UntypedFormControl(),
  });

  createForm = new UntypedFormGroup({
    displayText: new UntypedFormControl(null, [Validators.required]),
    order: new UntypedFormControl(),
    isActive: new UntypedFormControl(true, [Validators.required]),
    lookupTypeId: new UntypedFormControl([], [Validators.required]),
    ict: new UntypedFormControl([]),
    mappingLookUpFieldId: new UntypedFormControl(),
    value: new UntypedFormControl(),
    parentFieldId: new UntypedFormControl(),
  });
  ictSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'displayText',
    enableCheckAll: true,
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  mappingLookUps = [
    { id: null, value: 'Select' },
    { id: 21, value: 'Immigration Case Type' }
  ];


  constructor(private lookupApi: LookupApi, public modal: NgbActiveModal,
    private loader: LoaderService,
    private toast: ToastService,
    private common: CommonService) { }

  ngOnInit() {
    if (this.isEdit) {
      this.amendLookup.patchValue(this.lookupField);
      this.amendLookup.controls['value'].disable();
      if (this.lookupField.lookupTypeId == LookupTypeKeys.DOCUMENT_NAMES){
        this.loadDocumentTypes();
        this.isDefaultText = false;
      }
    }
    else {
      this.loadLookupData();
      if (this.lookUpTypeId != 0){
        this.createForm.controls.lookupTypeId.setValue(this.lookUpTypeId)
        this.createForm.controls.lookupTypeId.disable();
      if(this.lookUpTypeId == LookupTypeKeys.DOCUMENT_NAMES){
        this.loadDocumentTypes();
        this.isDefaultText = false;
      }
      }
    }
  }

  loadLookupData() {
    this.lookupApi.getEditableLookupTypes()
      .subscribe(resp => {
        this.lktypes = resp.filter(x => x.module ==  this.module);
      });
  }

  onUpdate() {
    this.loader.show();
    if (!this.createForm.getRawValue().order)
      this.createForm.controls.order.setValue(0);
    if (this.amendLookup.getRawValue().lookupTypeId == 38 && this.amendLookup.getRawValue().mappingLookUpFieldId != null) {
      this.SaveLookUpFieldsAndMapping(true, this.amendLookup.getRawValue());
    }
    else {
      this.lookupApi.saveLookupFields(true, this.amendLookup.getRawValue())
        .pipe(finalize(() => {
          this.loader.clear();
        }))
        .subscribe(resp => {
          if (resp.data != -99) {
            this.toast.success('Drop down successfully updated');
            this.modal.dismiss();
          } else {
            this.toast.warning('Cannot add duplicate value for drop down display text');
          }
        }, err => {
          this.toast.error('An error occurred. Please try again.');
        }
      );
    }
  }
  onSave() {
    this.loader.show();
    if (!this.createForm.getRawValue().order)
      this.createForm.controls.order.setValue(0);
    if (this.createForm.getRawValue().lookupTypeId == 38 && this.createForm.getRawValue().mappingLookUpFieldId != null) {
      this.SaveLookUpFieldsAndMapping(false, this.createForm.getRawValue());
    }
    else {
      this.lookupApi.saveLookupFields(false, this.createForm.getRawValue())
        .pipe(finalize(() => {
          this.loader.clear();
        }))
        .subscribe(resp => {
          if (resp.data != -99) {
            this.toast.success('Drop down successfully updated');
            this.modal.dismiss();
          } else {
            this.toast.warning('Cannot add duplicate value for drop down display text');
          }
        }, err => {
          this.toast.error('An error occurred. Please try again.');
        }
        );
    }
  }
  getMappedICT() {
    this.lookupApi.getMappedLookUpFieldValues(LookupTypeKeys.IMMIGRATION_CASE_TYPE, this.lookupField.id).subscribe(data => {
      this.mappedICTs = data;
      this.immigrationCaseTypes$.subscribe(val => {
        this.amendLookup.get('ict').setValue(val.filter(r => this.mappedICTs.includes(r.id)));
        this.amendLookup.get('ict').updateValueAndValidity();
      });
    });
  }
  onDropdownChange(e) {
    this.isDefaultText = true;
    if (e.target.textContent == 'Visa Type') {
      this.immigrationCaseTypes$ = this.common.prepareICTObservable();
    }
    if (e.target.textContent === 'Document Name') { 
      this.loadDocumentTypes();
      this.isDefaultText = false;
    } else {
      this.createForm.controls['value'].clearValidators();
      this.createForm.controls['value'].updateValueAndValidity();
      this.createForm.controls['parentFieldId'].clearValidators();
      this.createForm.controls['parentFieldId'].updateValueAndValidity();
    }

  }
  SaveLookUpFieldsAndMapping(isEdit, lookupField) {
    const selectedIds = lookupField.ict.map(({ id }) => id);
    const selectedIdsString = selectedIds.join(',');
    this.lookupApi.saveLookUpFieldsAndMapping(isEdit, selectedIdsString, lookupField)
      .pipe(finalize(() => {
        this.loader.clear();
      }))
      .subscribe(resp => {
        if (resp.data != -99) {
          this.toast.success('Drop down successfully updated');
          this.modal.dismiss();
        } else {
          this.toast.warning('Cannot add duplicate value for drop down display text');
        }
      }, err => {
        this.toast.error('An error occurred. Please try again.');
      }
      );
  }
  onlookUpChange(e) {
    if (e.value == 'Immigration Case Type') {
      this.immigrationCaseTypes$ = this.common.prepareICTObservable();
      if (this.isEdit) {
        this.getMappedICT();
      }
    }
  }
  loadDocumentTypes(){
    this.lookupApi.getLookupFieldsByTypes([LookupTypeKeys.DOCUMENT_TYPES])
    .subscribe(resp => {
      this.documentTypes = resp.filter(x => x.filterKeyId == 1);
      if(this.isEdit){
        this.amendLookup.controls['parentFieldId'].setValidators([Validators.required]);
        this.amendLookup.controls['parentFieldId'].updateValueAndValidity();
      }
      else{
        this.createForm.controls['parentFieldId'].setValidators([Validators.required]);
        this.createForm.controls['parentFieldId'].updateValueAndValidity();
        this.createForm.controls['value'].setValidators([Validators.required]);
        this.createForm.controls['value'].updateValueAndValidity();
      }
    });
  }
}
